import AppBadge from './AppBadge'

export default AppBadge